// Positions constants
export const positions = {
    topStart: "top-start",
    top: "top",
    topEnd: "top-end",
    rightStart: "right-start",
    right: "right",
    rightEnd: "right-end",
    bottomStart: "bottom-start",
    bottom: "bottom",
    bottomEnd: "bottom-end",
    leftStart: "left-start",
    left: "left",
    leftEnd: "left-end",
};

// Positions arrays to make easy to search for an specific position in a group.
export const topPositions = [positions.topStart, positions.top, positions.topEnd];
export const bottomPositions = [positions.bottomStart, positions.bottom, positions.bottomEnd];
export const leftPositions = [positions.leftStart, positions.left, positions.leftEnd];
export const rightPositions = [positions.rightStart, positions.right, positions.rightEnd];

// Vertical actions
export const verticalPositions = [
    positions.topStart,
    positions.top,
    positions.topEnd,
    positions.bottomStart,
    positions.bottom,
    positions.bottomEnd,
];

// Horizontal Positions
export const horizontalPositions = [
    positions.leftStart,
    positions.left,
    positions.leftEnd,
    positions.rightStart,
    positions.right,
    positions.rightEnd,
];
